// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as _ from "lodash";
import * as React from "react";
import { ApplicationThemeContext } from "./ApplicationThemeContext";
import { ApplicationEnvironmentContext } from "../ApplicationEnvironment";
import { useTheme } from "./hooks/useTheme";

// eslint-disable-next-line max-len
import { jsx as _jsx } from "react/jsx-runtime";
const toThemeVariant = domain => {
  const variant = domain.replace(/\..*/, "");
  return ["horizon", "millesime", "interco"].includes(variant) ? variant : "auto";
};
export const ApplicationThemeContextProvider = props => {
  const {
    children
  } = props;
  const {
    Provider
  } = ApplicationThemeContext;

  // const [color, setColor] = useTheme<ApplicationThemeColor>('color', 'blue');
  const [variant, setVariant] = useTheme("variant", toThemeVariant(window.location.hostname));
  const environment = React.useContext(ApplicationEnvironmentContext);
  React.useEffect(() => {
    if (variant && variant !== "auto") {
      document.body.classList.add(_.toString(variant));
      document.title = `${_.capitalize(variant)} 360 - Mairistem By JVS`;
    }
    switch (environment) {
      case "development":
        document.title = `[DEV] ${document.title}`;
        break;
      case "testing":
        document.title = `[QA] ${document.title}`;
        break;
      case "staging":
        document.title = `[PP] ${document.title}`;
        break;
      default:
        break;
    }
    return () => {
      if (variant && variant !== "auto") {
        document.body.classList.remove(_.toString(variant));
        document.title = "Mairistem By JVS";
      }
    };
  }, [variant, environment]);
  return React.useMemo(() => /*#__PURE__*/_jsx(Provider, {
    value: {
      variant,
      setVariant
    },
    children: children
  }), [variant, children]);
};